import * as React from 'react';

export interface Props extends React.HTMLAttributes<HTMLElement> {
  label: string;
}

export const Navigation = ({ children, label, ...restProps }: Props) => (
  <nav aria-label={label} {...restProps}>
    {children}
  </nav>
);
